import React, { useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import logo from '../assets/img/logo.svg';


function NavBar() {
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => {
			if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
		}
		window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
	},[])

	const onUpdateActiveLink = (value) => {
		setActiveLink(value)
	}

  return (
    <Navbar expand='lg' className={scrolled ? "scrolled" : ""}>
      <Container>
        {/* <Navbar.Brand href='#home'>
          <img src={logo} alt='Logo' />
        </Navbar.Brand> */}
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='ms-auto'>
            <Nav.Link
              href='#home'
              className={
                activeLink === "home" ? "active navbar-link" : "navbar-link"
              }
              onClick={() => onUpdateActiveLink("home")}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href='#skills'
              className={
                activeLink === "skills" ? "active navbar-link" : "navbar-link"
              }
              onClick={() => onUpdateActiveLink("skills")}
            >
              Skills
            </Nav.Link>
            <Nav.Link
              href='#projects'
              className={
                activeLink === "projects" ? "active navbar-link" : "navbar-link"
              }
              onClick={() => onUpdateActiveLink("projects")}
            >
              Projects
            </Nav.Link>
          </Nav>
          <span className='navbar-text'>
            <div className='social-icon'>
              <a href='https://www.linkedin.com/in/zarif-shahriar-rahman-634142173/' target='_blank' rel="noreferrer">
                <img src={navIcon1} alt='' />
              </a>
              <a href='#'>
                <img src={navIcon2} alt='' />
              </a>
              <a href='#'>
                <img src={navIcon3} alt='' />
              </a>
            </div>
            {/* <button
              className='vvd'
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/in/zarif-shahriar-rahman-634142173/",
                  "_blank"
                )
              }
            >
              <span>Let’s Connect</span>
            </button> */}
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;